/*
 * Copyright (c) 2023. PublishPress, All rights reserved.
 */

export const ButtonsPanel = function (props) {
    return (
        <div>
            {props.children}
        </div>
    )
}
